import React from "react";

const TablerIcon = ({ name, size = 24, className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}>
    {name === "shopping-cart" && (
      <>
        <circle cx="9" cy="21" r="1" />
        <circle cx="20" cy="21" r="1" />
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
      </>
    )}
    {name === "trash" && (
      <>
        <path d="M4 7h16" />
        <path d="M10 11v6" />
        <path d="M14 11v6" />
        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12" />
        <path d="M9 3v4h6V3" />
      </>
    )}
    {name === "plus" && (
      <>
        <path d="M12 5v14" />
        <path d="M5 12h14" />
      </>
    )}
    {name === "minus" && <path d="M5 12h14" />}
    {name === "credit-card" && (
      <>
        <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
        <path d="M1 10h22" />
      </>
    )}
    {name === "cash" && (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M4 5h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" />
      </>
    )}
    {name === "cash-register" && (
      <>
        <path d="M5 21h14" />
        <path d="M7 21v-4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4" />
        <path d="M9 15v-8a3 3 0 0 1 6 0v8" />
        <path d="M9 9h6" />
        <path d="M9 12h6" />
      </>
    )}
    {name === "alert-triangle" && (
      <>
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
        <path d="M10.29 3.86l-8.09 14a2 2 0 0 0 1.71 3.14h16.18a2 2 0 0 0 1.71-3.14l-8.09-14a2 2 0 0 0-3.42 0z" />
      </>
    )}
    {name === "search" && (
      <>
        <circle cx="10" cy="10" r="7" />
        <path d="M21 21l-6-6" />
      </>
    )}
    {name === "user" && (
      <>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
      </>
    )}
    {name === "package" && (
      <>
        <path d="M16.5 9.4l-9-5.19M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
        <path d="M12 22V12" />
        <path d="M3.3 7L12 12l8.7-5" />
      </>
    )}
    {name === "weight" && (
      <>
        <path d="M12 4a4 4 0 0 1 4 4c0 1.5-1 2-2 2-1 0-2-1-2-2 0-1 .5-2 2-2" />
        <path d="M12 4v8" />
        <path d="M12 4H8" />
        <path d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0z" />
      </>
    )}
    {name === "printer" && (
      <>
        <path d="M6 9V3h12v6" />
        <path d="M6 21H4a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2" />
        <path d="M6 15h12v6H6z" />
        <path d="M18 9v6" />
        <path d="M6 9v6" />
        <path d="M18 3v3" />
        <path d="M6 3v3" />
      </>
    )}
    {name === "receipt" && (
      <>
        <path d="M6 3h12v18l-3-2l-3 2l-3-2l-3 2z" />
        <path d="M9 8h6" />
        <path d="M9 12h6" />
        <path d="M9 16h3" />
      </>
    )}
    {name === "x" && (
      <>
        <path d="M18 6L6 18" />
        <path d="M6 6l12 12" />
      </>
    )}
    {name === "check" && <path d="M20 6L9 17l-5-5" />}
    {name === "category" && (
      <>
        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
        <path d="M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2" />
        <path d="M12 15a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
        <path d="M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944" />
        <path d="M11 7h2" />
      </>
    )}
  </svg>
);

export default TablerIcon;
